import { useEffect, useState } from 'react'

import emptyAvatarBoy from 'assets/icon/empty-avatar-boy.svg'
import emptyAvatarGirl from 'assets/icon/empty-avatar-girl.svg'

const Avatar = ({
  src = '',
  alt = 'Avatar',
  gender = 'M',
  className = '',
  defaultClassName = '',
}) => {
  const [isError, setIsError] = useState(false)

  const defaultAvatar = gender === 'F' ? emptyAvatarGirl : emptyAvatarBoy

  const handleLoadStart = () => {
    setIsError(false)
  }

  const handleError = () => {
    setIsError(true)
  }

  useEffect(() => {
    setIsError(false)
  }, [src])

  return (
    <img
      src={isError ? defaultAvatar : src && src.trim() ? src : defaultAvatar}
      alt={alt}
      className={`rounded-full object-cover bg-white ${className} ${isError || !(src && src.trim()) ? defaultClassName : ''}`}
      // onLoadStart={handleLoadStart}
      onError={handleError}
    />
  )
}

export default Avatar
